export const LOAD_ALIAS = "LOAD_ALIAS";
export const LOAD_ALIAS_SUCCESS = "LOAD_ALIAS_SUCCESS";
export const LOAD_ALIAS_ERROR = "LOAD_ALIAS_ERROR";
